export default __webpack_public_path__ + "static/media/kids.a45e23f1.jpg";